<div class="text-center loader-div">
  <img src="assets/images/loader.gif" alt="" class="load">
  <p *ngIf="showContent" class="mulish-normal text-sm text-white">{{"Generating result" | translate}}</p>
</div>